import type { ErrorHandler } from '@angular/core';
import { inject, Service } from '@angular/core';
import { AnalyticsService } from './analytics.service';

const normalizeError = (
  error: unknown
): { message: string; stack?: string } => {
  if (error instanceof Error) {
    return { message: error.message, stack: error.stack };
  }

  return { message: String(error) };
};

/**
 * Global Angular error handler that reports uncaught exceptions to PostHog.
 * Always logs to the console so local debugging is unaffected.
 */
@Service()
export class AnalyticsErrorHandler implements ErrorHandler {
  private readonly analytics = inject(AnalyticsService);

  /** Normalizes the error, logs locally, and forwards it to PostHog. */
  handleError(error: unknown): void {
    console.error(error);

    const normalized = normalizeError(error);
    this.analytics.capture('$exception', {
      message: normalized.message,
      stack: normalized.stack,
    });
  }
}
